import React from "react";

import AudioPlayer from "react-h5-audio-player";
import "react-h5-audio-player/lib/styles.css";

function KpkIncarceration() {
  return (
    <div className="py-5">
      <h2 className="text-h-black">Stories of Incarceration</h2>
      <div className="voice-sect">
        <div className="voice-sect-style">
          <p className="text-p-orange">Criminalising Dissent</p>
          <p>
            Wasim Mehsud was incarcerated in Peshawar Central Jail in 2019 for
            one and a half months, accused of violating cybercrime laws. In
            detention, he observed how socioeconomically vulnerable prisoners
            were treated.
          </p>
          <div className="my-5">
            <AudioPlayer
              // style={{ width: "300px" }}
              style={{ borderRadius: "1rem" }}
              className="bg-none"
              // autoPlay
              // layout="horizontal"
              src={require("../../assets/audio/WASEEM.wav")}
              //   onPlay={(e) => console.log("onPlay")}
              showSkipControls={true}
              showJumpControls={false}
              // other props here
            />
          </div>
        </div>
        <div className="voice-sect-style">
          <p className="text-p-orange">
            From Politicised Student to Political Criminal
          </p>
          <p>
            Ibrahim Khan was arrested for dissent in 2019. Politicised by the
            Pashtun Tahafuz Movement at Gomal University, he had posted a story
            on social media, contradicting the security forces’ account that
            they had found and killed terrorists in a town in South Waziristan.
            Ibrahim said his story was about how the law enforcement forces
            persecuted ordinary people who had nothing to do with terrorism.
          </p>
          <div className="my-5">
            <AudioPlayer
              // style={{ width: "300px" }}
              style={{ borderRadius: "1rem" }}
              className="bg-none"
              // autoPlay
              // layout="horizontal"
              src={require("../../assets/audio/IBRAHIM-KHAN.wav")}
              //   onPlay={(e) => console.log("onPlay")}
              showSkipControls={true}
              showJumpControls={false}
              // other props here
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default KpkIncarceration;
